var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table-status"},[_c('span',{staticClass:"icon",style:({backgroundColor:_vm.currStatus.backgroundColor})}),_vm._v("\n  "+_vm._s(_vm.currStatus.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }